import { useNavigate } from 'react-router-dom';
import SITE from '../data/site';
import { FaqItem, TestiCard } from '../components/UI';
import center from '../assets/center/alarrab-center.jpg';
import hero from '../assets/hero.jpeg';
import { useState } from 'react';
export default function Home() {
  const nav = useNavigate();
  const { clinic, stats, services, testimonials, faq } = SITE;

  const [open, setOpen] = useState(false);

  return (
    <div style={{ paddingTop: 72 }}>

      {/* ── HERO ── */}
      <section className="hero" >
        {/* style={{backgroundImage : `url(${hero})` , backgroundPosition : 'center', backgroundSize : 'contain'}} */}
        <div className="hero-bg" />
        <div className="hero-lines" />
        <div className="hero-fade" />
        <div className="container hero-inner">
          <div>
            <div className="hero-eyebrow">مركز متخصص في مصر الجديدة</div>
            <h1 className="hero-title">ابتسامتك<br />تستحق <span>الأفضل</span></h1>
            <p className="hero-subtitle">يضم مركز العراب نخبة من أفضل أطباء الأسنان المؤهلين وذوي خبرة في علاج وتجميل الأسنان باستخدام أحدث التقنيات والأجهزة الطبية.</p>
            <div className="hero-btns">
              <a className="btn btn-gold" href={clinic.whatsapp} target="_blank" rel="noreferrer">✦ احجز موعدك الآن</a>
              <a className="btn btn-outline" href={`tel:${clinic.phone}`}>📞 اتصل بنا</a>
            </div>
            <div className="hero-stats">
              {stats.map((s, i) => (
                <div className="hstat" key={i}>
                  <div className="hstat-num">{s.num}</div>
                  <div className="hstat-lbl">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div>
            {/* <div className="hero-card">
              <div className="hero-img-ph">

               <img src={center} className="logo-img" alt={'dd'} onError={e => e.target.style.display='none'} />
            
                <span className="ph-icon">🏥</span>
                <span className="ph-txt">ضع صورة المركز هنا</span>
              </div>
              <div className="hero-caption">
                <h3>{clinic.name}</h3>
                <p>{clinic.address}</p>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* ── WHY US ── */}
      <section className="sec sec-warm">
        <div className="container">
          <div className="why-grid">
            <div className="why-img-wrap">
              <div className="why-img-box">
                <div className="why-img-ph">
                  {/* <span className="ph-icon ">🦷</span>
                  <span className="ph-txt">صورة المركز</span> */}

                  <img src={center} className="logo-img" alt={'dd'} onError={e => e.target.style.display='none'} />
                </div>
              </div>
              <div className="why-badge">
                <div className="why-badge-num">١٠+</div>
                <div className="why-badge-lbl">سنوات<br />خبرة</div>
              </div>
            </div>
            <div>
              <span className="why-eyebrow">من نحن</span>
              <h2 className="why-title">لماذا تختار مركز العراب؟</h2>
              <p className="why-desc">عيادة العراب هي واحدة من أبرز عيادات الأسنان المتخصصة في تجميل وزراعة الأسنان في مصر، تتميز بأعلى معايير الجودة والكفاءة.</p>
              <div className="why-points">
                {[
                  ['🔬', 'أحدث التقنيات', 'نستمر في البحث واستقطاب أحدث التقنيات في طب الأسنان لتقديم خدمات طبية متطورة.'],
                  ['🌍', 'معايير عالمية', 'نقدم مستوى جديد من الخدمات المتميزة بالدقة والنجاح العالي على المستوى الدولي.'],
                  ['⭐', 'جودة وكفاءة', 'تجميل وزراعة أسنان بأعلى معايير الجودة والكفاءة.'],
                ].map(([icon, title, text]) => (
                  <div className="why-pt" key={title}>
                    <div className="why-pt-icon">{icon}</div>
                    <div><h4>{title}</h4><p>{text}</p></div>
                  </div>
                ))}
              </div>
              <button className="btn btn-gold" onClick={() => nav('/about')}>اعرف أكثر عنا</button>
            </div>
          </div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section className="sec">
        <div className="container">
          <div className="sec-head">
            <span className="sec-eyebrow">تخصصاتنا</span>
            <h2>خدماتنا</h2>
            <p>نلتزم بتقديم خدمات طب الأسنان بأعلى مستويات الجودة والدقة باستخدام أحدث التقنيات والأدوات المعقمة</p>
            <div className="gold-line" />
          </div>
          <div className="svc-grid">
            {services.map(s => (
              <div className="svc-card"  key={s.id} onClick={() => nav(`/services/${s.id}`)}>
                <div >
                  {s.img
                  ? <img className="svc-img" style={{objectFit : 'contain', width : '100%', objectPosition : 'center'}} src={s.img} alt={s.title} />
                  : <div className="svc-img-ph"><span className="ph-icon">{s.icon}</span><span className="ph-txt">{s.title}</span></div>
                }
                </div>
               
                <div className="svc-body">
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <span className="svc-arrow">اعرف أكثر →</span>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 34 }}>
            <button className="btn btn-gold" onClick={() => nav('/services')}>عرض جميع الخدمات</button>
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section className="sec sec-black">
        <div className="container">
          <div className="sec-head">
            <span className="sec-eyebrow">تجارب عملائنا</span>
            <h2>آراء العملاء</h2>
            <div className="gold-line" />
          </div>
          <div className="testi-grid">
            {testimonials.map((t, i) => <TestiCard key={i} img={t.img || t1} {...t} />)}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="sec sec-dark">
        <div className="container">
          <div className="sec-head">
            <span className="sec-eyebrow">أسئلة وأجوبة</span>
            <h2>الأسئلة الشائعة</h2>
            <div className="gold-line" />
          </div>
          <div className="faq-wrap">
            {faq.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} />)}
          </div>
        </div>
      </section>

      {/* ── CONTACT PREVIEW ── */}
      <section className="sec sec-warm " >
        <div className="container">
          <div className="sec-head">
            <span className="sec-eyebrow">تواصل معنا</span>
            <h2>للتواصل معنا</h2>
            <div className="gold-line" />
          </div>
          <div className="contact-grid" >
            <a href={`tel:${clinic.phone}`} className="ctc-card">
              <div className="ctc-icon">📞</div>
              <h3>رقم الاتصال والواتس اب</h3>
              <div className="ctc-val">{clinic.phone}</div>
            </a>
            <a href={`mailto:${clinic.email}`} className="ctc-card">
              <div className="ctc-icon">✉️</div>
              <h3>راسلنا</h3>
              <p>{clinic.email}</p>
            </a>
            <a href={clinic.mapUrl} target="_blank" rel="noreferrer" className="ctc-card">
              <div className="ctc-icon">📍</div>
              <h3>العنوان</h3>
              <p>{clinic.address}</p>
              {/* <p>{clinic.address2}</p> */}

            </a>
            
          </div>
        </div>
      </section>

    </div>
  );
}
